module.exports = __webpack_public_path__ + "img/xk.de26020.svg";